// @flow
/**
 * ThemePropertyException
 */
class ThemePropertyException extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ThemePropertyException";
  }
}

export default ThemePropertyException;
